import { render, staticRenderFns } from "./SimpleVerticalIndicator.vue?vue&type=template&id=2baab9e4&scoped=true"
import script from "./SimpleVerticalIndicator.vue?vue&type=script&lang=js"
export * from "./SimpleVerticalIndicator.vue?vue&type=script&lang=js"
import style0 from "./SimpleVerticalIndicator.vue?vue&type=style&index=0&id=2baab9e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2baab9e4",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/vuestic-theme/vuestic-components/vuestic-wizard/indicators/SimpleVerticalIndicator.vue
// module id = 1mf5
// module chunks = 41